import { render, staticRenderFns } from "./sales-return.vue?vue&type=template&id=1deb22c8&scoped=true"
import script from "./sales-return.vue?vue&type=script&lang=js"
export * from "./sales-return.vue?vue&type=script&lang=js"
import style0 from "./sales-return.vue?vue&type=style&index=0&id=1deb22c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1deb22c8",
  null
  
)

export default component.exports